<template>
  <div class="ie-popup">
    <div class="pop-wrap">
      <img src="@/assets/images/logo.svg" alt="">
      <h1><span>'미지원 브라우저'</span> 안내</h1>
      <p>
        UT 테스트 내용 설정 기능은 <span>인터넷 익스플로러(IE)</span>에서 지원되지 않습니다. 뷰저블 솔루션은 크롬에 최적화되어 있습니다.
      </p>
      <ul>
        <li>
          <a href="https://www.google.com/intl/ko/chrome/" target="_blank">
            <img src="@/assets/images/icon-google-chrome.svg" alt="">
            <span>Google Chrome</span>
          </a>
        </li>
        <li>
          <a href="https://www.microsoft.com/ko-kr/edge" target="_blank">
            <img src="@/assets/images/icon-browser-edge.svg" alt="">
            <span>Microsoft Edge</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'IEPopup',
  props: {

  }
}
</script>

<style lang="scss" scoped>
.ie-popup {
  display: block;
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: 0;

  .pop-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 530px;
    height: 440px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background: #fff;

    & > img {
      width: 112px;
      margin: 25px 0 0 25px;
    }

    h1 {
      font-size: 40px;
      font-weight: bold;
      color: #1e1e1e;
      text-align: center;
      margin-top: 60px;

      span {
        color: #ec0047;
        display: inline-block;
      }
    }

    p {
      font-size: 14px;
      color: #222;
      display: block;
      width: 420px;
      margin: 20px auto 35px;
      text-align: center;
      line-height: 1.64;
      span {
        font-weight: bold;
      }
    }

    ul {
      border: 2px solid #d7d7d7;
      width: 400px;
      height: 140px;
      background: #f4f4f4;
      margin: 0 auto;
      text-align: center;
      display: block;
      position: relative;

      li {
        margin-top: 30px;
        display: inline-block;
        margin-right: 50px;
        vertical-align: middle;

        a {
          display: block;

          span {
            display: block;
            font-size: 13px;
            font-weight: 600;
            margin-top: 10px;
          }
        }

        &:last-child {
          margin-right: 0;

          &::after {
            content: "";
            width: 1px;
            height: 35px;
            position: absolute;
            background: #d8d8d8;
            left: 50%;
            top: 40px;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
}

// /* IE10+ */
// @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
//   .ie-popup {
//     display: block;
//     position: fixed;
//     z-index: 9999;
//     width: 100%;
//     height: 100%;
//     background: rgba(0, 0, 0, 0.75);
//     top: 0;
//     left: 0;

//     .pop-wrap {
//       position: absolute;
//       left: 50%;
//       top: 50%;
//       transform: translateX(-50%) translateY(-50%);
//       width: 530px;
//       height: 460px;
//       background: #fff;
//       border: 6px solid #1e1e1e;
//       box-shadow: 0 30px 25px -17px rgba(0, 0, 0, 0.25);

//       & > img {
//         width: 88px;
//         margin: 15px 0 0 15px;
//       }

//       h1 {
//         font-size: 40px;
//         font-weight: bold;
//         color: #1e1e1e;
//         text-align: center;
//         margin-top: 50px;

//         span {
//           color: #ec0047;
//           display: inline-block;
//         }
//       }

//       p {
//         font-size: 14px;
//         color: #222;
//         display: block;
//         width: 420px;
//         margin: 20px auto 30px;
//         text-align: center;
//         line-height: 1.64;
//         span {
//           font-weight: bold;
//         }
//       }

//       ul {
//         border: 2px solid #d7d7d7;
//         width: 400px;
//         height: 140px;
//         background: #f4f4f4;
//         margin: 0 auto;
//         text-align: center;
//         display: block;
//         position: relative;

//         li {
//           margin-top: 30px;
//           display: inline-block;
//           margin-right: 50px;
//           vertical-align: middle;

//           a {
//             display: block;

//             span {
//               display: block;
//               font-size: 13px;
//               font-weight: 600;
//               margin-top: 10px;
//             }
//           }

//           &:last-child {
//             margin-right: 0;

//             &::after {
//               content: "";
//               width: 1px;
//               height: 35px;
//               position: absolute;
//               background: #d8d8d8;
//               left: 50%;
//               top: 40px;
//               transform: translateX(-50%);
//             }
//           }
//         }
//       }
//     }
//   }
// }
</style>
